<script setup>
import Prospectus from "@/components/pages/prospectus";
import merchApiDrive from "@/services/http/api-drive/magasin/merch";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useMagasinStore } from "@/store/magasin";

const { trackPage } = useTrackingPage();

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.prospectus);
});
const { id: magasinId } = useMagasinStore();
const { path } = useRoute();

let prospectusList = [];

const url = path.replace("/prospectus", "");

const { data } = await useAsyncData((app) =>
  cacheResponse(
    app.$apiServerCacheRedis,
    `${cacheKeys.prospectusPrefix}${magasinId}`,
    app.$apiDrive.use(merchApiDrive).prospectus(magasinId),
    useRuntimeConfig().public.API_DRIVE_CACHE_MAGASIN
  )
);

if (data.value) {
  prospectusList = data.value.data;
}

const prospectus = prospectusList.find((p) => {
  return (
    p.attributes.url.replace(/\/\//g, "/").includes(url) ||
    p.attributes.url.includes(url)
  );
});

useHead(() => {
  return {
    title: prospectus
      ? `Prospectus : ${prospectus.attributes.title}`
      : "Prospectus",
    link: [{ rel: "canonical", href: path }]
  };
});
</script>

<template>
  <Prospectus
    :url="url"
    :page="$route.query.page ? parseInt($route.query.page) : 1"
    :prospectus="prospectus"
  />
</template>

<style scoped lang="scss">
</style>
